<template>
  <v-container>
    <monitoreo-dinamico :number="number"></monitoreo-dinamico>
    <v-btn class="no-print" color="primary" @click="print" dark v-if="this.$store.state.routeSheet.status=='false'" >Imprimir</v-btn>
  </v-container>
</template>

<script>

import MonitoreoDinamico from "../monitoreo/MonitoreoDinamico"

export default {
  data: () => ({
    number: 37
  }),

  mounted() {
    //this.$validator.localize('en', this.dictionary)
  },

  methods: {
    submit() {
      //this.$validator.validateAll()
    },
    clear() {
      this.name = "";
      this.email = "";
      this.select = null;
      this.checkbox = null;
      //this.$validator.reset()
    },
    print(){
      this.$store.state.drawer = false
      this.$store.state.toolbar = false
      setTimeout(function(){
        window.print()
      }, 1000);
      let self=this
      setTimeout(function(){
        self.$store.state.toolbar = true
      }, 3000);
    }
  },
  components: {
    MonitoreoDinamico
  }
};
</script>


// WEBPACK FOOTER //
// src/components/patient/proessat/CuestionarioProessat.vue